module.exports = __webpack_public_path__ + "img/wifi.45af5166.svg";